<template>
  <div class="house-statistics">
    <el-tabs type="border-card" v-model="card_index">
      <el-tab-pane label="空置率统计" name="CenterDiscountMonthlyList">
        <CenterDiscountMonthlyList v-if="card_index==='CenterDiscountMonthlyList'"/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>

import CenterDiscountMonthlyList from "./components/CenterDiscountMonthlyList";

export default {
  name: "CenterDiscountMonthly",
  components: {CenterDiscountMonthlyList},
  data() {
    return {
      card_index: "CenterDiscountMonthlyList"
    }
  }
}
</script>

<style lang="scss" scoped>
.house-statistics {
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/HouseCode/CenterDiscountMonthly.vue